import { executeOnDocumentReady } from '../../utils.js';

import pageLocations from './js/page-locations.js';

import './style.scss';

executeOnDocumentReady(() => {
	pageLocations();
});
